module.exports = __webpack_public_path__ + "static/bandhan-b733bfc8d852ab99c2b7fd2d2f4f156f.png";